import { Dispatch } from 'redux';

import * as Actions from '../actions/scorm';
import AbstractScenario from './AbstractScenario';

/** eラーニングSCORM情報取得シナリオ用パラメータ */
export interface IFetchELearningScormParam {
	careerID: string;
	classID: string;
	itemID: string;
	seqNo: number;
	scoType: string;
	userId: string;
	isPreview: boolean;
}

/** eラーニングSCORM受講終了シナリオ用パラメータ */
export interface IEndELearningScormParam {
	careerID: string;
	classID: string;
	itemID: string;
	scoType: string;
	seqNo: number;
	userId: string;
	page: number;
	pageCount: number;
	startTime: string;
	isPreview: boolean;
}

/**
 * SCORMシナリオファクトリ
 */
export default class ScormScenarioFactory {
	/**
	 * eラーニングSCORM情報取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchELearningScorm(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			IFetchELearningScormParam
		> {
			protected process(arg: IFetchELearningScormParam) {
				const param = {
					accessType: arg.isPreview ? 21 : 10,
					actionKind: 'start',
					careerID: arg.careerID,
					classID: arg.classID,
					itemID: arg.itemID,
					scoType: arg.scoType,
					seqNo: arg.seqNo,
					userId: arg.userId,
					viewMode: arg.isPreview ? 1 : 0,
				};
				return this.read(
					'el_scorm_ELearningScormBlockModel',
					param
				).then(data => {
					const startTime: string = data.startTime;
					const location: string = data.location;
					dispatch(
						Actions.setScormParams({
							location,
							startTime,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * eラーニングSCORM受講終了シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createEndELearningScorm(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			IEndELearningScormParam
		> {
			protected process(arg: IEndELearningScormParam) {
				const param = {
					accessType: arg.isPreview ? 21 : 10,
					actionKind: 'end',
					careerID: arg.careerID,
					classID: arg.classID,
					id: 'update',
					itemID: arg.itemID,
					page: arg.page,
					pageCount: arg.pageCount,
					scoType: arg.scoType,
					seqNo: arg.seqNo,
					startTime: arg.startTime,
					userId: arg.userId,
					viewMode: arg.isPreview ? 1 : 0,
				};
				return this.update(
					'el_scorm_ELearningScormBlockModel',
					param
				).then(data => {
					//
				});
			}
		}(dispatch, token);
		return scenario;
	}
}



// WEBPACK FOOTER //
// ./src/scenario/ScormScenarioFactory.ts